import * as Yup from 'yup';

export const forgotPasswordSchema = Yup.object({
    email: Yup.string()
        .email('Podaj prawidłowy adres email')
        .required('Email jest wymagany')
        .default(''),
});

export type ForgotPasswordSchemaType = Yup.InferType<typeof forgotPasswordSchema>;

